// @ts-nocheck

import { ii, placeKitten } from 'vtils'

// @index(['./*.vue', './*/index.vue'], (f, _) => `import { default as Dmbc${_.pascal(f.path.replace('/index', ''))} } from '${f.path}'`)
import { default as DmbcBaseEmpty } from './base_empty/index'
import { default as DmbcBaseIcon } from './base_icon/index'
import { default as DmbcBaseLottie } from './base_lottie/index'
import { default as DmbcBaseMasonry } from './base_masonry/index'
import { default as DmbcBaseResource } from './base_resource/index'
import { default as DmbcBaseSquare } from './base_square/index'
import { default as DmbcBaseTabs } from './base_tabs/index'
import { default as DmbcBaseWaterfall } from './base_waterfall/index'
import { default as DmbcProxy } from './proxy/index'
import { default as DmbcResourceList } from './resource_list/index'
import { default as Dmbc使用规则UseRule } from './使用规则__USE_RULE/index'
import { default as Dmbc商品宫格CommodityLayer } from './商品宫格__COMMODITY_LAYER/index'
import { default as Dmbc商品推荐ClassifyCommodity } from './商品推荐__CLASSIFY_COMMODITY/index'
import { default as Dmbc商品橱窗2MarketingScene } from './商品橱窗2__MARKETING_SCENE/index'
import { default as Dmbc商品橱窗CommodityRotation } from './商品橱窗__COMMODITY_ROTATION/index'
import { default as Dmbc商品瀑布流CommodityFeed } from './商品瀑布流__COMMODITY_FEED/index'
import { default as Dmbc商品瀑布流CommodityFeed_2023Appliance } from './商品瀑布流__COMMODITY_FEED_2023_APPLIANCE/index'
import { default as Dmbc商品评论CommodityEvaluate } from './商品评论__COMMODITY_EVALUATE/index'
import { default as Dmbc图标宫格Classify } from './图标宫格__CLASSIFY/index'
import { default as Dmbc图片宫格ImageLayer } from './图片宫格__IMAGE_LAYER/index'
import { default as Dmbc店铺优惠券StoreDiscount } from './店铺优惠券__STORE_DISCOUNT/index'
import { default as Dmbc店铺公告StoreNotice } from './店铺公告__STORE_NOTICE/index'
import { default as Dmbc店铺关键词StoreLabel } from './店铺关键词__STORE_LABEL/index'
import { default as Dmbc店铺头部StoreHead } from './店铺头部__STORE_HEAD/index'
import { default as Dmbc文章列表ArticleItem } from './文章列表__ARTICLE_ITEM/index'
import { default as Dmbc普通列表CommonList } from './普通列表__COMMON_LIST/index'
import { default as Dmbc秒杀SkillActivity } from './秒杀__SKILL_ACTIVITY/index'
import { default as Dmbc简介Description } from './简介__DESCRIPTION/index'
import { default as Dmbc自定义区块Custom } from './自定义区块__CUSTOM/index'
import { default as Dmbc资源瀑布流2ActivityFeed } from './资源瀑布流2__ACTIVITY_FEED/index'
import { default as Dmbc资源瀑布流ClassifyFeed } from './资源瀑布流__CLASSIFY_FEED/index'
import { default as Dmbc轮播Banner } from './轮播__BANNER/index'
import { default as Dmbc页面Page } from './页面__PAGE/index'
import { default as Dmbc页面头部PageHead } from './页面头部__PAGE_HEAD/index'
import { default as Dmbc领券Coupon } from './领券__COUPON/index'
import { default as Dmbc领券Coupon_2023Appliance } from './领券__COUPON_2023_APPLIANCE/index'
// @endindex

export const install = (Vue: any, options: any) => {
  Vue.prototype.$place = placeKitten
  Vue.prototype.$transformPx = options?.transformPx || ((v: number) => `${v}px`)
  Vue.prototype.$dmbcApi = options.api
  Vue.prototype.$dmbcBack = options.back || (() => Vue.prototype.$router.back())
  Vue.prototype.$transformPxUnit = (() => {
    const onePx = Vue.prototype.$transformPx(1)
    const testEl = document.createElement('div')
    testEl.style.position = 'absolute'
    testEl.style.height = onePx
    testEl.style.padding = '0px'
    testEl.style.pointerEvents = 'none'
    testEl.style.opacity = '0'
    document.body.appendChild(testEl)
    const height = testEl.getBoundingClientRect().height
    document.body.removeChild(testEl)
    return height
  })()

  const ua = window.navigator.userAgent.toLowerCase()
  const platform = window.navigator.platform.toLowerCase()
  const dcbIos = !!~ua.indexOf('dcb-app-ios')
  const dcbAndroid = !!~ua.indexOf('dcb-app-android')
  const dcb = dcbIos || dcbAndroid || !!~ua.indexOf('dcb-app')
  const ios = dcbIos || /ipad|iphone|ipod/.test(platform)
  const android = dcbAndroid || !!~ua.indexOf('android')
  const wechat = !!~ua.indexOf('micromessenger')
  const alipay = !!~ua.indexOf('alipayclient')
  const yancheng = !!~ua.indexOf('ycsmt')
  const inGuangDa = ua.includes('yunjiaofeiclient')
  const inLove = ua.includes('love-calculator')
  const env = Object.freeze({
    dcb: dcb,
    ios: ios,
    android: android,
    wechat: wechat,
    alipay: alipay,
    yancheng: yancheng,
    inGuangDa: inGuangDa,
    inLove: inLove,
    statusBarHeight: ii(() => {
      if (!dcb && !inLove) return '0px'
      if (ios) {
        return Vue.prototype.$transformPx(window.screen.height > 800 ? 36 : 20)
      }
      return Vue.prototype.$transformPx(
        window.screen.height === window.outerHeight ? 25 : 40,
      )
    }),
  })
  Vue.prototype.$dmbcEnv = env

  Vue.prototype.$dmbcResourceClick = (res: any, trackFrom?: string) => {
    res = typeof res === 'string' ? { targetUrl: res } : res
    return res && options.handleResourceClick(res, trackFrom)
  }

  const patchComponent = (componentName: string, component: any) => {
    if (component.__is_patched) return component
    component.__is_patched = true
    component.options.name = componentName
    if (!componentName.startsWith('DmbcBase')) {
      component.options.props = component.options.props || {}
      Object.assign(component.options.props, {
        // extend 后 :null 会被转为 { type: null }
        theme: { type: null },
        data: { type: null },
        componentType: { type: null },
        componentId: { type: null },
        pageId: { type: null },
        pageName: { type: null },
        pageTheme: { type: null },
      })
      component.options.methods = component.options.methods || {}
      Object.assign(component.options.methods, {
        getTrackExtra(res) {
          return {
            page_id: this.pageId,
            page_name: this.pageName,
            component_id: this.componentId,
            component_name: this.componentType,
            resource_id: res.id,
            resource_name: res.title,
          }
        },
      })
    }
    return component
  }
  // @index(['./*.vue', './*/index.vue'], (f, _) => `Vue.component('Dmbc${_.pascal(f.path.replace('/index', ''))}', patchComponent('Dmbc${_.pascal(f.path.replace('/index', ''))}', Dmbc${_.pascal(f.path.replace('/index', ''))}))`)
  Vue.component('DmbcBaseEmpty', patchComponent('DmbcBaseEmpty', DmbcBaseEmpty))
  Vue.component('DmbcBaseIcon', patchComponent('DmbcBaseIcon', DmbcBaseIcon))
  Vue.component(
    'DmbcBaseLottie',
    patchComponent('DmbcBaseLottie', DmbcBaseLottie),
  )
  Vue.component(
    'DmbcBaseMasonry',
    patchComponent('DmbcBaseMasonry', DmbcBaseMasonry),
  )
  Vue.component(
    'DmbcBaseResource',
    patchComponent('DmbcBaseResource', DmbcBaseResource),
  )
  Vue.component(
    'DmbcBaseSquare',
    patchComponent('DmbcBaseSquare', DmbcBaseSquare),
  )
  Vue.component('DmbcBaseTabs', patchComponent('DmbcBaseTabs', DmbcBaseTabs))
  Vue.component(
    'DmbcBaseWaterfall',
    patchComponent('DmbcBaseWaterfall', DmbcBaseWaterfall),
  )
  Vue.component('DmbcProxy', patchComponent('DmbcProxy', DmbcProxy))
  Vue.component(
    'DmbcResourceList',
    patchComponent('DmbcResourceList', DmbcResourceList),
  )
  Vue.component(
    'Dmbc使用规则UseRule',
    patchComponent('Dmbc使用规则UseRule', Dmbc使用规则UseRule),
  )
  Vue.component(
    'Dmbc商品宫格CommodityLayer',
    patchComponent('Dmbc商品宫格CommodityLayer', Dmbc商品宫格CommodityLayer),
  )
  Vue.component(
    'Dmbc商品推荐ClassifyCommodity',
    patchComponent(
      'Dmbc商品推荐ClassifyCommodity',
      Dmbc商品推荐ClassifyCommodity,
    ),
  )
  Vue.component(
    'Dmbc商品橱窗CommodityRotation',
    patchComponent(
      'Dmbc商品橱窗CommodityRotation',
      Dmbc商品橱窗CommodityRotation,
    ),
  )
  Vue.component(
    'Dmbc商品橱窗2MarketingScene',
    patchComponent('Dmbc商品橱窗2MarketingScene', Dmbc商品橱窗2MarketingScene),
  )
  Vue.component(
    'Dmbc商品瀑布流CommodityFeed_2023Appliance',
    patchComponent(
      'Dmbc商品瀑布流CommodityFeed_2023Appliance',
      Dmbc商品瀑布流CommodityFeed_2023Appliance,
    ),
  )
  Vue.component(
    'Dmbc商品瀑布流CommodityFeed',
    patchComponent('Dmbc商品瀑布流CommodityFeed', Dmbc商品瀑布流CommodityFeed),
  )
  Vue.component(
    'Dmbc商品评论CommodityEvaluate',
    patchComponent(
      'Dmbc商品评论CommodityEvaluate',
      Dmbc商品评论CommodityEvaluate,
    ),
  )
  Vue.component(
    'Dmbc图标宫格Classify',
    patchComponent('Dmbc图标宫格Classify', Dmbc图标宫格Classify),
  )
  Vue.component(
    'Dmbc图片宫格ImageLayer',
    patchComponent('Dmbc图片宫格ImageLayer', Dmbc图片宫格ImageLayer),
  )
  Vue.component(
    'Dmbc店铺优惠券StoreDiscount',
    patchComponent('Dmbc店铺优惠券StoreDiscount', Dmbc店铺优惠券StoreDiscount),
  )
  Vue.component(
    'Dmbc店铺公告StoreNotice',
    patchComponent('Dmbc店铺公告StoreNotice', Dmbc店铺公告StoreNotice),
  )
  Vue.component(
    'Dmbc店铺关键词StoreLabel',
    patchComponent('Dmbc店铺关键词StoreLabel', Dmbc店铺关键词StoreLabel),
  )
  Vue.component(
    'Dmbc店铺头部StoreHead',
    patchComponent('Dmbc店铺头部StoreHead', Dmbc店铺头部StoreHead),
  )
  Vue.component(
    'Dmbc文章列表ArticleItem',
    patchComponent('Dmbc文章列表ArticleItem', Dmbc文章列表ArticleItem),
  )
  Vue.component(
    'Dmbc普通列表CommonList',
    patchComponent('Dmbc普通列表CommonList', Dmbc普通列表CommonList),
  )
  Vue.component(
    'Dmbc秒杀SkillActivity',
    patchComponent('Dmbc秒杀SkillActivity', Dmbc秒杀SkillActivity),
  )
  Vue.component(
    'Dmbc简介Description',
    patchComponent('Dmbc简介Description', Dmbc简介Description),
  )
  Vue.component(
    'Dmbc自定义区块Custom',
    patchComponent('Dmbc自定义区块Custom', Dmbc自定义区块Custom),
  )
  Vue.component(
    'Dmbc资源瀑布流ClassifyFeed',
    patchComponent('Dmbc资源瀑布流ClassifyFeed', Dmbc资源瀑布流ClassifyFeed),
  )
  Vue.component(
    'Dmbc资源瀑布流2ActivityFeed',
    patchComponent('Dmbc资源瀑布流2ActivityFeed', Dmbc资源瀑布流2ActivityFeed),
  )
  Vue.component(
    'Dmbc轮播Banner',
    patchComponent('Dmbc轮播Banner', Dmbc轮播Banner),
  )
  Vue.component('Dmbc页面Page', patchComponent('Dmbc页面Page', Dmbc页面Page))
  Vue.component(
    'Dmbc页面头部PageHead',
    patchComponent('Dmbc页面头部PageHead', Dmbc页面头部PageHead),
  )
  Vue.component(
    'Dmbc领券Coupon_2023Appliance',
    patchComponent(
      'Dmbc领券Coupon_2023Appliance',
      Dmbc领券Coupon_2023Appliance,
    ),
  )
  Vue.component(
    'Dmbc领券Coupon',
    patchComponent('Dmbc领券Coupon', Dmbc领券Coupon),
  )
  // @endindex
}

export default { install }
